import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  ADMIN_PARTNERS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

import {
  AFFILIATES_UNCONFIRMED_LIST_ROUTE_NAME,
  AFFILIATES_UNCONFIRMED_PERMISSIONS,
  AFFILIATES_UNCONFIRMED_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATES_UNCONFIRMED,
} from './constants';
import { getTranslationKeys } from './translations';

export class AffiliatesUnconfirmedModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: AFFILIATES_UNCONFIRMED_ROUTE_NAME,
      path: 'unconfirmed-partners',
      permission: AFFILIATES_UNCONFIRMED_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'AffiliatesUnconfirmedListPage',
    });

    router.addChildRoute(AFFILIATES_UNCONFIRMED_ROUTE_NAME, {
      name: AFFILIATES_UNCONFIRMED_LIST_ROUTE_NAME,
      path: '',
      permission: AFFILIATES_UNCONFIRMED_PERMISSIONS.SHOW,
      component: () => import('./pages/AffiliatesUnconfirmedListPage/AffiliatesUnconfirmedListPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_PARTNERS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'PARTNERS_UNCONFIRMED_PARTNERS'),
      to: {
        name: AFFILIATES_UNCONFIRMED_LIST_ROUTE_NAME,
      },
      permission: AFFILIATES_UNCONFIRMED_PERMISSIONS.SHOW,
      id: AFFILIATES_UNCONFIRMED_LIST_ROUTE_NAME,
      order: 10,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATES_UNCONFIRMED, getTranslationKeys);
  }
}
